import AvatarDetails from "@/components/AvatarDetails";
import { JobPost } from "@/pages/_layouts/jobs/types";
import SectionHeading from "@/components/SectionHeading";

interface JobContactInfoProps {
  jobPost: JobPost;
}

export function JobContactInfo({ jobPost }: JobContactInfoProps) {
  // Default to using the point of contact if available; fallback to employer otherwise.
  const contact = jobPost.pointOfContact?.name ? jobPost.pointOfContact : jobPost.employer;

  return contact ? (
    <div data-testid="job-contact-info" className="border-0 border-b border-sys-brand-secondary-container pb-8">
      <SectionHeading heading="Contact" />
      <AvatarDetails
        title={contact.name}
        // Only show the title if we're using the pointOfContact (since Employer lacks a title).
        secondaryText={contact === jobPost.pointOfContact ? jobPost.pointOfContact?.title : undefined}
        text={
          <>
            <p>{contact.email}</p>
            <p>{contact.phone}</p>
          </>
        }
      />
    </div>
  ) : null;
}
